import React, { useState, useEffect } from 'react';
import { Container, Typography, Card, CardContent, Button, TextField, FormControlLabel, Switch } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createClient } from '../Servies/AdmiServices';
import Loader from '../components/common/Loader';


export default function CreateClient() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    clientName: '',
    clientNumber: '',
    schoolName: '',
    schoolAddress: '',
    schoolEmail: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddClient = (e) => {
    e.preventDefault();
    setIsLoading(true);
    createClient({ ...formData, isSchool: checked })
      .then((response) => {
        setIsLoading(false);
        if (response.status === 401) {
          toast.error(response.data?.error || "Unauthorized", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else if (response.data?.SUCCESS === true) {
          toast.success("Client Added!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate(-1);
        } else {
          toast.error(response.data?.MESSAGE || "Error occured while creating client", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error("Error occured!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.error('Error fetching user data:', error);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <Helmet>
        <title> Dashboard: Client Register </title>
      </Helmet>
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Add New Client
        </Typography>
        <Card sx={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', width: '750px', margin: 'auto' }}>
          <CardContent>
            <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <TextField name="clientName" label="Client Name"
                variant="outlined" required
                value={formData.clientName} onChange={handleChange}
              />

              <TextField name="clientNumber" label="Client Number"
                variant="outlined" required
                value={formData.clientNumber} onChange={handleChange}
              />

              <FormControlLabel
                control={<Switch checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                label="Is School"
              />

              <TextField name="schoolName" label="School Name"
                variant="outlined"
                value={formData.schoolName} onChange={handleChange}
              />
              <TextField name="schoolAddress" label="School Address"
                variant="outlined"
                value={formData.schoolAddress} onChange={handleChange}
              />

              <TextField name="schoolEmail" label="School Email"
                variant="outlined"
                value={formData.schoolEmail} onChange={handleChange}
              />

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <Button type="submit" variant="contained" style={{ width: '150px', alignSelf: 'center', marginLeft: '1rem' }}
                  onClick={handleAddClient}
                >
                  Submit
                </Button>

                <Button type="button" variant="contained"
                  sx={{ width: '120px', textAlign: 'center', marginLeft: '2rem', backgroundColor: 'white', color: 'black', }}
                  onClick={() => { navigate(-1); }}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
